import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import GameRulesModal from '../Components/Modals/GameRulesModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'GameRules'>;

const GameRulesScreen: React.FC<Props> = ({ navigation }) => {
	return <GameRulesModal onClose={() => navigation.goBack()} />;
};

export default GameRulesScreen;
